var $29450c8b4443f473$exports = {};
// Ui.Tooltip is handed its control as opaque Html, so no id can travel between
// the bubble and the thing it describes in Elm. Both ends are wired here. With
// nothing focusable inside — plain text, or a disabled control — the wrapper
// takes focus, since a bubble that appears on hover is one a keyboard cannot
// reach.
const $29450c8b4443f473$var$TEXT = '.tooltip__text';
const $29450c8b4443f473$var$FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
const $29450c8b4443f473$var$DESCRIBABLE = 'a[href], button, input:not([type="hidden"]), select, textarea';
let $29450c8b4443f473$var$tooltipIds = 0;
const $29450c8b4443f473$var$MANAGED = /^elm-tooltip-\d+-text$/;
function $29450c8b4443f473$var$describe(node, tooltipId) {
    const ids = [
        ...new Set((node.getAttribute('aria-describedby') ?? '').split(' ').filter((id)=>id && !$29450c8b4443f473$var$MANAGED.test(id)).concat(tooltipId))
    ];
    node.setAttribute('aria-describedby', ids.join(' '));
}
class $29450c8b4443f473$var$ElmTooltip extends HTMLElement {
    connectedCallback() {
        this.tooltipId ??= `elm-tooltip-${++$29450c8b4443f473$var$tooltipIds}`;
        this.wire();
        this.observer = new MutationObserver(()=>this.wire());
        this.observer.observe(this, {
            childList: true,
            subtree: true
        });
    }
    disconnectedCallback() {
        this.observer?.disconnect();
    }
    own(selector) {
        const found = this.querySelector(selector);
        return found && found.closest('elm-tooltip') === this ? found : null;
    }
    wire() {
        const text = this.own($29450c8b4443f473$var$TEXT);
        if (!text) return;
        text.id ||= `${this.tooltipId}-text`;
        text.setAttribute('role', 'tooltip');
        const focusable = this.own($29450c8b4443f473$var$FOCUSABLE);
        const described = focusable ?? this.own($29450c8b4443f473$var$DESCRIBABLE);
        if (described) $29450c8b4443f473$var$describe(described, text.id);
        if (focusable) {
            this.removeAttribute('tabindex');
            this.removeAttribute('aria-describedby');
            this.standIn(null);
            return;
        }
        // A bubble that only shows on hover is one a keyboard cannot reach.
        this.tabIndex = 0;
        // An aria-hidden icon says nothing itself, so the wrapper stands in for it
        // and takes the text as its name: a description on a generic is not read
        // while arrowing through a page. Where the wrapper holds a disabled
        // control or text of its own, that content is what should be read, and the
        // tooltip stays a description of it.
        if (described || this.ownText(text)) {
            $29450c8b4443f473$var$describe(this, text.id);
            this.standIn(null);
            return;
        }
        this.removeAttribute('aria-describedby');
        this.standIn(text.id);
    }
    // role=img makes the children presentational, so it is only ever set on a
    // wrapper whose children have nothing to say.
    standIn(id) {
        if (!id) {
            this.removeAttribute('role');
            this.removeAttribute('aria-labelledby');
            return;
        }
        this.setAttribute('role', 'img');
        this.setAttribute('aria-labelledby', id);
    }
    // What a reader would hear from the wrapper's own children. An aria-hidden
    // icon is not it, which is the case the img role exists for.
    ownText(text) {
        const bubble = text.closest('.tooltip');
        return [
            ...this.childNodes
        ].filter((node)=>node !== bubble && node.getAttribute?.('aria-hidden') !== 'true').map((node)=>node.textContent).join('').trim();
    }
}
if (!customElements.get('elm-tooltip')) customElements.define('elm-tooltip', $29450c8b4443f473$var$ElmTooltip);


//# sourceMappingURL=provider-portal.0f1aa549.js.map
